import Vue from 'vue'
import { Notify } from 'vant'
import axios from 'axios'


Vue.use(Notify)

const service = axios.create({
    //baseURL: 'http://localhost:8091', // url = base url + request url
    baseURL: process.env.VUE_APP_SXURL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // if the custom code is not 200, it is judged as an error.
        if (res.code && res.code !== 200) {
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Notify({ type: 'warning', message: error.message || 'Error!' });
        return Promise.reject(error)
    }
)

export default service